import React, { useState, useEffect } from "react";
import Select from "react-select";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";

const Area = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [areaMaster, setAreaMaster] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [areaType, setAreaType] = useState([]);
  const [areaGroup, setAreaGroup] = useState([]);
  console.log("areaGroup", areaGroup);
  const [formData, setFormData] = useState({
    Name: "",
    Code: "",
    Description: "",
    AreaType_012: null,
    GroupID: null,
    IsInActive: 0,
    ZipCode: "",
  });

  const columns = {
    Code: { text: "Code", align: "start", visible: true },
    Name: { text: "Name", align: "start", visible: true },
    ZipCode: { text: "Zip Code", align: "center", visible: true },
    IsInActive: { text: "Active", align: "center", visible: true },
  };
  const defaultColumns = {
    Code: true,
    Name: true,
    IsInActive: true,
    ZipCode: true,
    AreaType_012: true,
    GroupID: true,
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Area"))
  }, [])
  const fetchArea = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}area-master`);
      const data = response?.data?.data;
      const updatedData = data.map((item) => ({
        ...item,
        IsInActive: item.IsInActive === 0 ? "No" : "Yes",
      }));
      setAreaMaster(updatedData);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  useEffect(() => {
    fetchArea();
  }, []);

  const resetFormState = () => {
    setFormData({
      Name: "",
      Code: "",
      Description: "",
    });
    setIsEditMode(false); // Reset edit mode state
  };


  const fetchCalenderDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}area-type`);
      //  Area Type Option
      const areatype = response.data.areaType;
      const options = areatype.map((comp) => ({
        value: comp.value,
        label: comp.text,
      }));
      setAreaType(options);
    } catch (error) {
      console.error("Error fetching JobType options:", error);
    }
  };

  useEffect(() => {
    fetchCalenderDetails();
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;
  
    setFormData({
      ...formData,
      [name]: newValue,
    });
  
    // Clear the error for the field being changed
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const handleAreaGrp = (name, selectedOption) => {
    setFormData({
      ...formData,
      [name]: selectedOption,
    });
  
    // Clear the error for GroupID
    if (errors.GroupID) {
      setErrors({
        ...errors,
        GroupID: null,
      });
    }
  };

  const handleAreaChange = async (name, selectedOption) => {
    try {
      setFormData({
        ...formData,
        [name]: selectedOption,
        GroupID: null, // Clear GroupID when AreaType changes
      });
  
      // Clear the error for AreaType_012
      if (errors.AreaType_012) {
        setErrors({
          ...errors,
          AreaType_012: null,
        });
      }
  
      await postDataToApi(selectedOption.value);
    } catch (error) {
      console.error("Error posting data to API", error);
    }
  };

  const handleEdit = async (id) => {
    console.log("check Area ID", id);
    setShowModal(true);
    setIsEditMode(true);

    try {
      // Fetch the selected area's data and dependencies concurrently
      const [response, areaTypes, areaGroups] = await Promise.all([
        GetServiceCaller(`${API_URL}area-master/${id.ID}`),
        fetchCalenderDetails(),
        postDataToApi(id.AreaType_012), // Ensure areaType and areaGroup are populated before setting formData
      ]);

      if (response.status === 200) {
        const depData = response?.data?.data;

        if (depData) {
          const {
            Name,
            Code,
            Description,
            AreaType_012,
            GroupID,
            IsInActive,
            ZipCode,
          } = depData;

          const selectedAreaType = areaType.find(
            (type) => type.value === AreaType_012
          );
          const selectedAreaGroup = areaGroups.find(
            (group) => group.value === GroupID
          );

          setFormData({
            id: id.ID,
            Name: Name || "",
            Code: Code || "",
            Description: Description || "",
            AreaType_012: selectedAreaType || null,
            GroupID: selectedAreaGroup || null,
            ZipCode: ZipCode || "",
            IsInActive: IsInActive === 1 ? 1 : 0,
          });
        }
      } else {
        console.error(
          "Failed to fetch Area Master details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Area Master details:", error);
    }
  };

  const postDataToApi = async (selectedValue) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await PostServiceCaller(
          `${API_URL}get-area-details-by-type`,
          {
            area_type: selectedValue,
          },
          "post"
        );
        console.log("API response:", response.data.details);
        const areagrp = response.data.details;
        const options = areagrp.map((comp) => ({
          value: comp.ID,
          label: comp.Name,
        }));
        setAreaGroup(options);
        resolve(options);
      } catch (error) {
        console.error("Error posting data to API", error);
        reject(error);
      }
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.Name) newErrors.Name = "Name is required";
    if (!formData.AreaType_012)
      newErrors.AreaType_012 = "Area Type is required";
    if (!formData.GroupID) newErrors.GroupID = "Area Group is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      const method = isEditMode ? "put" : "post";
      const apiUrl = isEditMode
        ? `${API_URL}area-master/${formData.id}`
        : `${API_URL}area-master`;

      // Create a new object with the necessary transformations
      const transformedFormData = {
        ...formData,
        AreaType_012: formData.AreaType_012
          ? formData.AreaType_012.value
          : null,
        GroupID: formData.GroupID ? formData.GroupID.value : null,
      };

      try {
        const response = await PostServiceCaller(
          apiUrl,
          transformedFormData,
          method
        );
        console.log("Submitted form data:", response.data);

        if (method === "post") {
          toast.success("Form submitted successfully!");
        } else {
          toast.success("Form updated successfully!");
        }
        resetFormState();
        fetchArea();
        setIsEditMode(false);
        setShowModal(false);
      } catch (error) {
        console.error("There was an error submitting the form data!", error);
        toast.error("Error submitting form data.");
      }
    }
  };

  const handleAdd = () => {
    setShowModal(true);
  };

  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
  };

  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row mt-2">
              <Dynamic_PR_table
                data={areaMaster}
                columns={columns}
                defaultColumns={defaultColumns}
                itemsPerPage={8}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                isSorting={true}
                isActionRequired={true}
                isAddNewBtnRequired={true}
                handleIcon1={handleEdit}
                handleAddNew={handleAdd}
                icons={{
                  Icon1: <i className="bi bi-pencil-square icons"></i>,
                }}
              />
            </div>
          </div>
          {/* Bootstrap Modal */}
          {showModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <div className="modal-dialog modal-dialog-centered modal-md" role="document">
                <div className="modal-content">
                  <div className="modal-header d-flex justify-content-between" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px 8px 0 0'
        }}>
                    <p style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#27568B',
            margin: '0'
          }}>Area</p>
                    <span className="me-2">
                      <i
                        className="bi bi-x-lg"
                        onClick={handleEditModalClose}
                      ></i>
                    </span>
                  </div>
                  <div className="modal-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-4">
                            <div class="mb-3">
                              <label for="Code" class="form-label">
                                Code
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="Code"
                                aria-describedby="Code"
                                name="Code"
                                placeholder="Code"
                                disabled
                                value={formData.Code}
                                onChange={handleInputChange}
                              />
                              {errors.Code && (
                                <div className="invalid-feedback">
                                  {errors.Code}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-8">
                            <div class="mb-3">
                              <label for="Code" class="form-label">
                                Name<span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control ${
                                  errors.Name ? "is-invalid" : ""
                                }`}
                                id="Name"
                                aria-describedby="Name"
                                name="Name"
                                placeholder="Name"
                                value={formData.Name}
                                onChange={handleInputChange}
                              />
                              {errors.Name && (
                                <div className="invalid-feedback">
                                  {errors.Name}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-6">
                            <div class="mb-3">
                              <label for="Code" class="form-label">
                                Description
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="Description"
                                aria-describedby="Description"
                                name="Description"
                                placeholder="Description"
                                value={formData.Description}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div class="mb-3">
                              <label for="Code" class="form-label">
                                Area Type<span className="required">*</span>
                              </label>
                              <Select
                                value={formData.AreaType_012}
                                options={areaType}
                                name="AreaType_012"
                                onChange={(selectedOption) =>
                                  handleAreaChange(
                                    "AreaType_012",
                                    selectedOption
                                  )
                                }
                                className={`form-control p-0 ${
                                  errors.AreaType_012 ? "is-invalid" : ""
                                }`}
                              />
                              {errors.AreaType_012 && (
                                <div className="invalid-feedback">
                                  {errors.AreaType_012}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-6">
                            <div class="mb-3">
                              <label for="Code" class="form-label">
                                Area Group<span className="required">*</span>
                              </label>
                              <Select
                                value={formData.GroupID}
                                onChange={(selectedOption) =>
                                  handleAreaGrp("GroupID", selectedOption)
                                }
                                options={areaGroup}
                                name="GroupID"
                                className={`form-control p-0 ${
                                  errors.GroupID ? "is-invalid" : ""
                                }`}
                                aria-describedby="type"
                              />
                              {errors.GroupID && (
                                <div className="invalid-feedback">
                                  {errors.GroupID}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-6">
                            <div class="mb-3">
                              <label for="Code" class="form-label">
                                Zipcode
                              </label>
                              <input
                                type="number"
                                name="ZipCode"
                                onChange={handleInputChange}
                                class="form-control"
                                value={formData.ZipCode}
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="row">
                              <div className="col-sm-3">
                                <label
                                  htmlFor="flexSwitchCheckChecked"
                                  className="form-label me-2"
                                >
                                  Active
                                </label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="IsInActive"
                                  id="flexSwitchCheckChecked"
                                  checked={formData.IsInActive === 1}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="text-end mt-2">
                          <button
                            className="cancel-btn me-2"
                            onClick={handleEditModalClose}
                          >
                            Cancel
                          </button>
                          <button type="submit" className="custom-btn">
                            Submit
                          </button>
                        </div>
                      </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
    </>
  );
};

export default Area;
